_ = require 'underscore'

{ Analytics } = require '@trello/atlassian-analytics'
{ track } = require '@trello/analytics'
{ getKey, Key } = require '@trello/keybindings'

Util = require 'app/scripts/lib/util'
removeAllRanges = require 'app/scripts/lib/util/removeAllRanges'
Controller = require 'app/scripts/controller'

module.exports.saveBoardName = (e) ->
  boardInput = @$('.js-board-name-input')
  val = boardInput && boardInput.val().trim()
  if val == ''
    boardInput.focus().select()
    return

  track("Board", "Successfully Rename Board")
  if @sendCoreGASEvent
    Analytics.sendTrackEvent
      action: 'set'
      actionSubject: 'boardName',
      source: 'boardScreen'
      containers:
        board:
          id: @model.id

  @model.update("name", val)
  return

module.exports.keyDownEvent = (e) ->
  if getKey(e) == Key.Enter
    Util.stop(e) # prevents new lines.
    @stopRenaming()
    return

  if getKey(e) == Key.Escape
    @stopRenaming()
    return

  return

module.exports.onInputChanged = (e) ->
  input = @$el.find('.js-board-name-input')[0]

  # First, we set the input width to 0, then we can measure how wide it needs to be for the content.
  input.style.width = '0'
  inputWidthForNewValue = input.offsetWidth

  # An element's scrollLeft represents the amount the element has been scrolled.
  # Setting an element's scrollLeft actually scrolls the element rather than setting the value,
  # and it can only scroll as far as the content goes— so here we're scrolling all the way to
  # the end of the content by using an absurd number.
  input.scrollLeft = 1e+10
  # With the width set to zero and the input scrolled to the end of the content, the element's
  # scrollLeft value is the width of the content! Now we add that to the offset.
  inputWidthForNewValue += input.scrollLeft

  # Here we make sure the input doesn't fall off the side of the page. The "-24" is for paddding.
  boardHeader = @$el.find('.js-board-header')[0]
  maxWidth = boardHeader.offsetWidth - 24
  inputWidth = if inputWidthForNewValue < maxWidth then inputWidthForNewValue else maxWidth

  # Now we have an input that's only as wide as the content needs, without running off the page.
  input.style.width = inputWidth + 'px'

  return

module.exports.startRenaming = (e) ->
  Util.stop(e)

  return if @isEditingName

  renameButton = @$el.find('.js-rename-board')[0]
  return if !renameButton

  inputWidth = renameButton.offsetWidth

  _.defer =>
    @$('.js-rename-board').addClass('is-editing')
    @$('.js-board-name-input')
      .val(@model.get('name'))
      .css('width', inputWidth)
      .focus()
      .select()

  @isEditingName = true
  track("Board Header", "Open Rename Board From Title")
  if @sendGASEvent
    Analytics.sendUIEvent
      action: 'clicked'
      actionSubject: 'input',
      actionSubjectId: 'boardNameInput'
      source: 'boardScreen'
      containers:
        board:
          id: @model.id

  return

module.exports.stopRenaming = (e) ->
  return if !@isEditingName

  $input = @$('.js-rename-board').removeClass('is-editing')
  if $input.is(":focus") then $input.blur()
  removeAllRanges()

  @isEditingName = false
  @saveBoardName()

  return

module.exports.updateControllerTitle = ->
  Controller.title(@model.get('name'))
